import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ComponentsModule } from "src/app/components/components.module";
import {  DepositInstaDebitActionPage } from "./deposit-instadebit-action";
@NgModule({
  declarations: [DepositInstaDebitActionPage],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
})
export class DepositInstaDebitActionPageModule {}
